import { List, ListItemButton, Select, styled } from "@mui/material"

import { IStyledList, IStyledListItemButton } from "./NavigationLinks.types"

export const StyledList = styled(List)<IStyledList>(
  ({ theme, direction: flexDirection = "column" }) => ({
    display: "flex",
    flexDirection,
    gap: theme.spacing(2),
    justifyContent: flexDirection === "column" ? "flexStart" : "center",
    alignItems: flexDirection === "column" ? "flexStart" : "center",
    height: "100%"
  })
)

export const StyledSelect = styled(Select)(({ theme }) => ({
  boxShadow: "none",

  ".MuiOutlinedInput-notchedOutline": {
    border: theme.spacing(0)
  },
  ".MuiSelect-select": {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0)
  }
}))

export const StyledListItemButton = styled(
  ListItemButton
)<IStyledListItemButton>(() => ({
  minWidth: "fit-content"
}))
